export default {
  title: 'Perché rigenerare questa immagine?',
  description: "Aiutaci a migliorare l'IA indicando cosa non andava.",
  reasons: {
    wrong_style: 'Stile errato',
    wrong_colors: 'Colori errati',
    wrong_food_item: 'Alimento errato',
    low_quality: 'Bassa qualità',
    doesnt_match_brand: 'Non corrisponde al mio brand',
    text_issues: 'Testo o etichette errati',
    other: 'Altro',
  },
  details_label: 'Altro? (facoltativo)',
  details_placeholder: 'Aggiungi dettagli per aiutarci a capire…',
  cancel: 'Annulla',
  confirm: 'Rigenera',
};
